import React from 'react'
import { makeStyles } from '@material-ui/styles'
import CustomCheckbox from './Checkbox'


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex', justifyContent: 'center', alignItems: 'center'
  },
  switch: {
    color: '#818284'
  },
  span: {
    marginLeft: '0.25em',
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
    cursor: 'pointer'
  }
}))


export default function TermsOfService(props) {
  const { click, checked, change } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <CustomCheckbox
        className={classes.switch}
        checked={checked}
        change={change}
        label={''} />
      I accept the <span className={classes.span} onClick={click}>Terms Of Service</span>
    </div>
  )
}
